import { transport } from 'config/transport';

export function callApiSaveThuChiCTPV(congDoanId, yearMonth, body) {
    return transport.post(`/ctpv/thuchi/congDoan/${congDoanId}`, body, { params: { yearMonth } });
}
